// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/talksCardBack.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.container {
  display: flex;
  justify-content: center;
}

/* Rectangle Card Layout */
.rectangle {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 380px;
  height: 300px;
  border-radius: 4px;
  box-shadow: 0px 20px 50px #d9dbdf;
  transition: all 0.3s ease;
  margin-top: 50px;
}

.rectangle:hover {
  box-shadow: 0 20px 40px #ffffff;
}

.dark-rectangle {
  box-shadow: 0px 0px 20px 0px;
}

.mask {
  clip: rect(0px, 460px, 220px, 0px);
  border-radius: 4px;
  position: absolute;
}

/* Card  Styling */
.talk-card-title {
  color: #ffffff;
  margin: auto;
  text-align: left;
  margin-top: 25px;
  padding: 0px 0px 40px 30px;
  font-size: 30px;
  line-height: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.talk-card-subtitle {
  margin-top: 35px;
  text-align: justify;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 16px;
  color: #7f8287;
  line-height: 18px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.talk-button {
  background-color: #55198b;
  color: #ffffff;
  width: 90px;
  padding: 10px 18px;
  border-radius: 3px;
  text-align: center;
  text-decoration: none;
  display: block;
  margin-top: 20px;
  font-size: 14px;
  cursor: pointer;
}

.talk-button:hover {
  background: #8c43ce;
}

.card-footer-button-div {
  display: flex;
  justify-content: space-around;
}

/* Media Query */
@media (max-width: 1380px) {
  .card-title {
    font-size: 25px;
  }
}
@media (max-width: 768px) {
  .mask {
    -webkit-clip-path: none;
            clip-path: none;
    position: relative;
  }
  .talk-card-title {
    margin-top: 30px;
  }
  .talk-card-image {
    width: 100%;
  }
  .talk-button {
    background-color: #55198b;
    color: #ffffff;
    width: 90px;
    padding: 10px 18px;
    border-radius: 3px;
    text-align: center;
    text-decoration: none;
    display: block;
    margin-top: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s ease-in;
  }
  .talk-button:hover {
    background: #8c43ce;
  }
  .card-footer-button-div {
    display: flex;
    justify-content: space-around;
  }
  .square {
    width: 100%;
    height: auto;
    padding-bottom: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/talkCard/TalkCard.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,aAAA;EACA,uBAAA;AAEF;;AACA,0BAAA;AACA;EACE,mDAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iCAAA;EAGA,yBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,+BAAA;AAGF;;AADA;EACE,4BAAA;AAIF;;AAFA;EACE,kCAAA;EACA,kBAAA;EACA,kBAAA;AAKF;;AAFA,kBAAA;AACA;EACE,cDfc;ECgBd,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAKF;;AAHA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cDrCiB;ECsCjB,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAMF;;AAJA;EACE,yBDtDY;ECuDZ,cD1Cc;EC2Cd,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAOF;;AALA;EACE,mBDlEY;AC0Ed;;AANA;EACE,aAAA;EACA,6BAAA;AASF;;AANA,gBAAA;AACA;EACE;IACE,eAAA;EASF;AACF;AAPA;EACE;IACE,uBAAA;YAAA,eAAA;IACA,kBAAA;EASF;EAPA;IACE,gBAAA;EASF;EAPA;IACE,WAAA;EASF;EANA;IACE,yBD7FU;IC8FV,cDjFY;ICkFZ,WAAA;IACA,kBAAA;IACA,kBAAA;IACA,kBAAA;IACA,qBAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;IACA,wBAAA;EAQF;EANA;IACE,mBD1GU;ECkHZ;EANA;IACE,aAAA;IACA,6BAAA;EAQF;EALA;IACE,WAAA;IACA,YAAA;IACA,oBAAA;EAOF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.container {\n  display: flex;\n  justify-content: center;\n}\n\n/* Rectangle Card Layout */\n.rectangle {\n  background: url(../../assets/images/talksCardBack.svg);\n  width: 380px;\n  height: 300px;\n  border-radius: 4px;\n  box-shadow: 0px 20px 50px $darkBoxShadow;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  margin-top: 50px;\n}\n.rectangle:hover {\n  box-shadow: 0 20px 40px $textColorDark;\n}\n.dark-rectangle {\n  box-shadow: 0px 0px 20px 0px;\n}\n.mask {\n  clip: rect(0px, 460px, 220px, 0px);\n  border-radius: 4px;\n  position: absolute;\n}\n\n/* Card  Styling */\n.talk-card-title {\n  color: $textColorDark;\n  margin: auto;\n  text-align: left;\n  margin-top: 25px;\n  padding: 0px 0px 40px 30px;\n  font-size: 30px;\n  line-height: normal;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.talk-card-subtitle {\n  margin-top: 35px;\n  text-align: justify;\n  padding-left: 30px;\n  padding-right: 30px;\n  font-size: 16px;\n  color: $talkCardSubTitle;\n  line-height: 18px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.talk-button {\n  background-color: $buttonColor;\n  color: $textColorDark;\n  width: 90px;\n  padding: 10px 18px;\n  border-radius: 3px;\n  text-align: center;\n  text-decoration: none;\n  display: block;\n  margin-top: 20px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.talk-button:hover {\n  background: $buttonHover;\n}\n.card-footer-button-div {\n  display: flex;\n  justify-content: space-around;\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .card-title {\n    font-size: 25px;\n  }\n}\n@media (max-width: 768px) {\n  .mask {\n    clip-path: none;\n    position: relative;\n  }\n  .talk-card-title {\n    margin-top: 30px;\n  }\n  .talk-card-image {\n    width: 100%;\n  }\n\n  .talk-button {\n    background-color: $buttonColor;\n    color: $textColorDark;\n    width: 90px;\n    padding: 10px 18px;\n    border-radius: 3px;\n    text-align: center;\n    text-decoration: none;\n    display: block;\n    margin-top: 20px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: 0.2s ease-in;\n  }\n  .talk-button:hover {\n    background: $buttonHover;\n  }\n  .card-footer-button-div {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .square {\n    width: 100%;\n    height: auto;\n    padding-bottom: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
